module.exports = __webpack_public_path__ + "static/media/photo129.11060a3a.jpg";